import getBugsnagClient from './getBugsnagClient';

const safeReportToBugsnag = (content: any, opts?: any) => {
  try {
    const client = getBugsnagClient();

    // eslint-disable-next-line no-console
    const log = (console[opts?.severity as keyof Console] ??
      // eslint-disable-next-line no-console
      console.log) as typeof console.log;

    log(`Bugsnag: ${opts?.severity}`, { content, opts });
    if (!client) return;

    client.notify(content, opts);
  } catch (e) {
    console.error('Error occurred when sending notificaton to bugsnag', e);
  }
};

/**
 * Will report an error to bugsnag if client is available
 */
export const reportErrorToBugsnag = (e: Error, options = {}) => {
  safeReportToBugsnag(e, { ...options, severity: 'error' });
};

/**
 * Will report an info message to bugsnag if client is available
 */
export const reportInfoToBugsnag = (info: string, options = {}) => {
  safeReportToBugsnag(info, { ...options, severity: 'info' });
};
